module.exports = __webpack_public_path__ + "img/Faltenglättung.c21eca20.jpg";